/**
 * Página: Logística
 */
import SegmentPage from '../../components/SegmentPage'

const segment = {
  name: 'Logística',
  tagline: 'Eficiência que move sua operação.',
  description: 'Controle de motoristas, operadores de empilhadeira e equipes de armazém. Produtividade em tempo real e compliance com NR-11.',
  icon: '🚛',
  color: '#06B6D4',
  gradient: 'linear-gradient(135deg, #06B6D4 0%, #3B82F6 100%)',
  painPoints: [
    'Motoristas em rotas sem controle de jornada',
    'Operadores de empilhadeira sem EPI verificado',
    'Produtividade de picking difícil de medir',
    'Múltiplos turnos com escalas complexas',
    'Compliance com NR-11 para movimentação',
    'Rotatividade alta de colaboradores',
  ],
  benefits: [
    'Ponto facial no início e fim de rota',
    'Verificação de EPI antes de operar empilhadeira',
    'Produtividade de picking por operador',
    'Gestão de escalas e turnos automática',
    'Rastreamento de atividade no armazém',
    'Onboarding rápido com reconhecimento facial',
  ],
  nrs: ['NR-11', 'NR-6', 'NR-12', 'NR-17'],
  stats: [
    { value: '+28%', label: 'Produtividade' },
    { value: '-50%', label: 'Atrasos' },
    { value: '97%', label: 'Compliance' },
    { value: '1min', label: 'Onboarding' },
  ],
  testimonial: {
    quote: 'O picking aumentou 28% quando os operadores viram que estavam sendo medidos. Transparência funciona.',
    author: 'Fernando Costa',
    role: 'Gerente de CD',
    company: 'LogiTrans Express',
  },
}

export default function Logistica() {
  return <SegmentPage segment={segment} />
}

